/**
 * External browse URLs for Jira / GitHub references in Slack rich text.
 */

import type { ExternalLinkConfig } from '../domain/slackMrkdwn';
import { DEFAULT_EXTERNAL_LINKS } from '../domain/slackMrkdwn';

export function getExternalLinkConfig(): ExternalLinkConfig {
  const jira =
    import.meta.env.VITE_JIRA_BROWSE_BASE?.trim() || DEFAULT_EXTERNAL_LINKS.jiraBrowseBase;
  const github =
    import.meta.env.VITE_GITHUB_PR_BASE?.trim() || DEFAULT_EXTERNAL_LINKS.githubPrBase;
  return {
    jiraBrowseBase: jira.replace(/\/+$/, ''),
    githubPrBase: github,
  };
}
